import React from "react"
import memoize from "memoize-one"
import Typography from "@material-ui/core/Typography"
import Hidden from "@material-ui/core/Hidden"
import ProfileIcon from "react-icons/lib/md/account-circle"
import LoopIcon from "react-icons/lib/md/loop"
import NotificationsIcon from "react-icons/lib/md/notifications"
import get from "lodash/get"
import SecurityIcon from "react-icons/lib/md/security"
import SettingsIcon from "react-icons/lib/md/settings"
import isEmpty from "lodash/isEmpty"
import StarIcon from "../../../lib/views/Icons/Star"
import Leaderboard from "../../../lib/views/Icons/Leaderboard"
import LanguageIcon from "../../../lib/views/Icons/Language"
import constants from "../../../constants"

const createTab = (classes, tab) => ({
    id: tab.id,
    title: (
        <Typography color="inherit" variant="button" className={classes.tab}>
            {tab.icon}
            <Hidden xsDown>
                <span className={classes.tabTitle}>{tab.name}</span>
            </Hidden>
        </Typography>
    ),
    url: tab.url,
})

export const createTabs = memoize((t, classes, notificationsTitle, course, userRole) => {
    const showLeaderboard = get(course, "show_leaderboard", false)
    const tabItems = [{
        id: 1,
        icon: <ProfileIcon size={24} />,
        name: t("main:profile"),
        url: "view",
        isShow: true,
    }, {
        id: 2,
        icon: <Leaderboard color="currentColor" />,
        name: t("main:leaderboard"),
        url: "leaderboard",
        isShow: showLeaderboard,
    }, {
        id: 3,
        icon: <StarIcon width={24} height={24} />,
        name: t("main:favourites"),
        url: "favourites",
        isShow: true,
    }, {
        id: 9,
        icon: <SettingsIcon size={24} />,
        name: t("main:manage_preferences"),
        url: "preferences",
        isShow: true,
    }, {
        id: 4,
        icon: <LanguageIcon width={24} height={24} />,
        name: t("main:language"),
        url: "language",
        isShow: true,
    }, {
        id: 5,
        icon: <LoopIcon size={24} />,
        name: t("main:change_course"),
        url: "change_course",
        // hide changeCourse tab if user have manager role
        isShow: userRole !== constants.userRoles.manager,
    }, {
        id: 6,
        icon: <NotificationsIcon size={24} />,
        name: notificationsTitle || t("main:notifications"),
        url: "notifications",
        isShow: true,
    }, {
        id: 7,
        icon: <SecurityIcon size={24} />,
        name: t("main:legal_policies"),
        url: "privacy_and_cookies",
        isShow: true,
    }
    ]

    return tabItems
        .filter(tab => tab.isShow === true)
        .map(tab => createTab(classes, tab))
})

export const getTitle = memoize((page, t, notificationsTitle) => {
    switch (page) {
        case "view": return t("main:profile")
        case "edit": return t("main:edit_profile")
        case "language": return t("main:language")
        case "settings": return t("main:settings")
        case "favourites": return t("main:favourites")
        case "change_course": return t("main:change_course")
        case "preferences": return t("main:manage_preferences")
        case "journey": return t("main:journey")
        case "dashboard": return t("main:dashboard")
        case "knowledge": return t("main:knowledge")
        case "manager": return t("main:manager")
        case "messages": return t("main:messages")
        case "notifications":
        case "notificationsDetail":
            return notificationsTitle
        case "leaderboard": return t("main:leaderboard")
        case "privacy_and_cookies": return t("main:legal_policies")
        default: return t("main:account")
    }
})

export const getSelectedTab = memoize((page, course) => {
    const showLeaderboard = get(course, "show_leaderboard", false)
    // indexForCourses: 1 if "change course" shows, and keeps other tabs in place
    // indexForLeaderboard: 1 if "leaderboard" tab will show
    let indexForLeaderboard = 1
    let indexForCourses = 1
    if (isEmpty(course)) {
        indexForCourses = 0
    }
    if (!showLeaderboard) {
        indexForLeaderboard = 0
    }
    if (page.includes("preferences")) { return (2 + indexForLeaderboard) }
    switch (page) {
        case "view": return 0
        case "edit": return 0
        case "leaderboard": return indexForLeaderboard
        case "favourites": return (1 + indexForLeaderboard)
        case "language": return (3 + indexForLeaderboard)
        case "change_course": return (3 + indexForCourses + indexForLeaderboard)
        case "notifications":
        case "notificationsDetail":
            return (4 + indexForLeaderboard + indexForCourses)
        case "privacy_and_cookies":
            return (5 + indexForLeaderboard + indexForCourses)
        default: return 0
    }
})

export default {
    createTabs,
    getTitle,
}
